import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    record: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const myProfileSlice = createSlice({
  name: 'myProfile',
  initialState,
  reducers: {
    getMyProfile: (state) => {
        state.record.requesting = true;
        state.record.error = null;
        state.record.data = null;
        state.record.success = false; 
    },
    getMyProfileSuccess: (state, action) => {
        console.log(action.payload);
        state.record.requesting = false;
        state.record.data = action.payload;
        state.record.success = true; 
    },
    getMyProfileFail: (state, action) => {        
        state.record.requesting = false;
        state.record.error = action.payload;
    },
    doMyProfileUpdate: (state) => {
        state.record.requesting = true;
        state.record.error = null;
        state.record.data = null;
        state.record.success = false; 
    },
    doMyProfileDelete: (state) => {
        state.record.requesting = true;
        state.record.error = null;
        state.record.data = null;
        state.record.success = false; 
    },
  },
})

export const { 
    getMyProfile, getMyProfileSuccess, getMyProfileFail,
    doMyProfileCreate, doMyProfileUpdate, doMyProfileDelete
} = myProfileSlice.actions

export default myProfileSlice.reducer